import React from "react";
import { Empty } from "antd";
import CenterSpin from "../../misc/spin";
import { MapContainer, TileLayer, LayerGroup, GeoJSON } from "react-leaflet";
import TooltipCircle from "../../misc/tooltipCircle";
import "leaflet/dist/leaflet.css";
import Legend from "../../misc/Legend";

export default function CardMap({
  countryProps,
  mapData,
  isLoading,
  geoJSONData,
  selectedDataType,
  isMapJsonReady,
  isDataAvailable,
  country,
  language,
}) {
  return (
    <div className="card-graph">
      {mapData && !isLoading ? (
        isMapJsonReady ? (
          <div
            style={{
              height: "100%",
              width: "100%",
              position: "relative",
            }}
          >
            <MapContainer
              style={{
                height: "100%",
                zIndex: "1",
              }}
              center={[countryProps.coor.lat, countryProps.coor.long]}
              zoom={countryProps.coor.zoom}
              zoomSnap={0.25}
              zoomControl={false}
            >
              <TileLayer
                url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                attribution='&copy; <div style="margin-right: 20px;"><a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a></div>'
                subdomains="abcd"
                maxZoom={20}
              />
              <GeoJSON
                data={geoJSONData}
                style={{
                  color: "transparent",
                  fillColor: "rgba(23, 124, 197, 0.5)",
                  weight: 1.5,
                }}
              />
              <LayerGroup>
                {mapData.points.map((point, i) => {
                  return (
                    <TooltipCircle
                      text={point.metro_zone}
                      lat={point.latitude}
                      long={point.longitude}
                      value={point.value}
                      max={mapData.max}
                      min={mapData.min}
                      zoomVal={countryProps.coor.zoom}
                      isXeno={selectedDataType.startsWith("xeno")}
                      isVolume={selectedDataType.endsWith("volume")}
                      key={i}
                      language={language}
                    />
                  );
                })}
              </LayerGroup>
              {isDataAvailable ? (
                <Legend
                  maxValue={mapData.max}
                  minValue={mapData.min}
                  zoom={countryProps.coor.zoom}
                  isXeno={selectedDataType.startsWith("xeno")}
                  isVolume={selectedDataType.endsWith("volume")}
                  language={language}
                />
              ) : null}
            </MapContainer>
          </div>
        ) : (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Empty
              style={{ width: "100%" }}
              description={
                <span style={{ fontSize: "24px" }}>
                  Sin datos para {country}
                </span>
              }
            />
          </div>
        )
      ) : (
        <CenterSpin />
      )}
    </div>
  );
}
